import React from "react";
import { ListItem, ListItemIcon, ListItemText, Grid } from "@material-ui/core";
import { format } from "date-fns";
import EventIcon from "@material-ui/icons/Event";
import { IMilestone } from "../types";
interface Props {
  milestone: IMilestone;
}

const MilestoneItem: React.FC<Props> = ({ milestone }) => {
  const milestoneDeadlineDate = new Date(Date.parse(milestone.DeadlineDate));
  return (
    <>
      <ListItemIcon>
        <EventIcon />
      </ListItemIcon>
      <ListItemText>
        <Grid container>
          <Grid item xs={6}>
            {milestone.WebName || milestone.AdminName}
          </Grid>
          <Grid item xs={6}>
            {format(milestoneDeadlineDate, "MM/dd/yyyy")}
            {milestone.AdditionalInfo && (
              <span>&nbsp;({milestone.AdditionalInfo})</span>
            )}
          </Grid>
        </Grid>
      </ListItemText>
    </>
  );
};

export default MilestoneItem;
